// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__u6Cez","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3d4C4"};